let MethodsUrl = {
    uploadFile:"/api/upload",
    removeMedia:"/api/deleteMedia",

    initApp:"/api/initApp",

    login:"/api/login",
    phonelogin:"/api/phonelogin",
    logoff:"/api/logoff",
    getUserInfo: "/api/getInfo",
    // getSiteInfo:"/api/getSiteInfo",
    getMenu : "/api/getMenu",


    getRoles :"/api/GetRoles",
    getGridDefinition: "/api/getGrid/",
    readContentItems:"/api/readItems",
    readContentItemsByContentItemIds:"/api/readItemsByContentItemId",
    deleteContentItems:"/api/deleteContentItems",
    forceDeleteContentItems:"/api/forceDeleteContentItems",
    deleteContentItem:"/api/deleteContentItem/",
    batchUpdataItem:"/api/batchUpdateItems",

    getGroupResultByKey:"/api/groupResultByKey",
    queryContentItemCount:"/api/queryContentItemCount",
    newContentItem:"/api/newContentItem/",
    createContentItem:"/api/createContentItem/",
    editContentItem:"/api/editContentItem/",
    updateContentItem:"/api/updateContentItem/",
    displayContentItem:"/api/displayContentItem/",
    workflowExe:"/api/WorkflowTrigger/",
    queryOptions:"/api/queryOptions",
    queryOptionsByValue:"/api/queryOptionsByValue",


    previewExcelData:"/api/import/getData",
    getFieldInfo:"/api/initImport",
    importDataByExcel:"/api/importData",
    superImportDataByExcel:"/api/superImportData",

    exportExcel:"/api/exportExcel",

    getDepart:"/api/getDepart",
    getFieldDefinition:"/api/getFieldDefinitions",
    getCSRF:"/api/getCSRFToken",
    
    getAllUser:"/api/getAllUser",
    getUserByFilter:"/api/getUserByFilter",
    searchUser:"/api/searchUserByNickName",

    getAuditTrail:"/api/ContentItemAuditTrail/",
    getAuditDetail:"/api/ContentItemAuditDetail/",
    getWorkflowAuditTrail:"/api/workflowsByContentItemId/",

    getSQLQueryResult:"/api/Query/",
    getUsersByName:"/api/getUsersByName",
    getFlowNodes:"/api/getFlowNodeDefinitions/",
    getFlowNodesByContentType:"/api/GetFlowNodes/",
    getFlowContentTypeList:"/api/GetContentTypes?IsFlow=true&AllContentType=false",
    getContentTypeList:"/api/GetContentTypes?AllContentType=true",
    getJsApiConfig:"/api/getJsApiConfig",
    externalLogin:"/api/ExternalLogin",

    sendCode: "/api/sendCode",
    checkInCode: "/api/checkCode",

    getDashboard: "/api/dashboard",
    getInfoByName: "/api/getInfoByName/",

    getContentItems:"", 

    getNotifications:"/api/readNotifications",
    readNotificationById:"/api/readNotificationById",
    getUnReadNotificationCount:"/api/getUnReadNotificationCount",
    readAllNotification:"/api/readAllNotification",

    todoTask:"/api/todoTask",
    ownerTask:"/api/ownerTask"
}

export {
    MethodsUrl
}

export type JsApiResult = {
    AppId:string,
    Timestamp:string,
    NonceStr:string,
    Signature:string,
    JsTiket:string,
}


export type Filter = {
    filters:Array<Filter>,
    logic:string
}
